import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 14",
	fill: "none",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.75,
			y: 2.75,
			width: 10.5,
			height: 9.5,
			rx: 1,
			stroke: "currentColor",
			strokeWidth: 1,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.75 5.75H12.25",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 1.5V3.75",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 1.5V3.75",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.5,
			cy: 8.5,
			r: .75,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7,
			cy: 8.5,
			r: .75,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9.5,
			cy: 8.5,
			r: .75,
			fill: "currentColor"
		})
	]
});
export default SvgCalendar;
